// Mock data for Children Planet Birthday Party Cafe

export const packages = [
  {
    id: 'mini-magic',
    name: 'Mini Magic',
    price: 250,
    popular: false,
    features: [
      '2 Hours Party Time',
      '+ 0.5 Hours Preparation',
      'Up to 10 Kids',
    ],
  },
  {
    id: 'super-star',
    name: 'Super Star',
    price: 350,
    popular: true,
    features: [
      '3 Hours Party Time',
      '+ 0.5 Hours Preparation',
      'Up to 15 Kids',
      "Bottle of Children's Champagne",
    ],
  },
  {
    id: 'vip-wonderland',
    name: 'VIP Wonderland',
    price: 600,
    popular: false,
    bestValue: true,
    features: [
      '5 Hours Party Time',
      '+ 0.5 Hours Preparation',
      'Custom Cake Included',
      'Up to 20 Kids',
    ],
  },
];

export const addOns = [];

export const menuItems = {
  kids: [
    {
      id: 'mini-sliders',
      name: 'Mini Sliders',
      description: 'Three juicy bite-sized beef burgers with crispy fries and a side of golden smile fries',
      price: 12.0,
      image: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=400',
    },
    {
      id: 'fairy-pasta',
      name: 'Fairy Pasta',
      description: 'Magical colorful bowtie pasta tossed in a light parmesan sauce',
      price: 10.0,
      image: 'https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?w=400',
    },
    {
      id: 'chicken-tenders',
      name: 'Chicken Tenders',
      description: 'Crispy golden hand-breaded chicken strips with honey mustard and fresh carrot sticks',
      price: 11.0,
      image: 'https://images.unsplash.com/photo-1562967914-608f82629710?w=400',
    },
  ],
  adult: [
    {
      id: 'gourmet-burger',
      name: 'Gourmet Burger',
      description: 'Premium beef patty with artisan toppings',
      price: 16.0,
      image: 'https://images.unsplash.com/photo-1550547660-d9450f859349?w=400',
    },
    {
      id: 'caesar-salad',
      name: 'Caesar Salad',
      description: 'Fresh romaine with parmesan and croutons',
      price: 14.0,
      image: 'https://images.unsplash.com/photo-1546793665-c74683f339c1?w=400',
    },
  ],
  drinks: [
    {
      id: 'magic-smoothie',
      name: 'Magic Smoothie',
      description: 'Tropical fruit blend',
      price: 6.0,
      image: 'https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=400',
    },
    {
      id: 'hot-chocolate',
      name: 'Hot Chocolate',
      description: 'Rich Belgian chocolate with marshmallows',
      price: 5.0,
      image: 'https://images.unsplash.com/photo-1542990253-a781e04c0082?w=400',
    },
  ],
  desserts: [
    {
      id: 'birthday-cake',
      name: 'Birthday Cake Slice',
      description: 'Celebration cake with rainbow layers',
      price: 8.0,
      image: 'https://images.pexels.com/photos/35224348/pexels-photo-35224348.jpeg?w=400',
    },
    {
      id: 'ice-cream-sundae',
      name: 'Ice Cream Sundae',
      description: 'Three scoops with toppings',
      price: 7.0,
      image: 'https://images.unsplash.com/photo-1563805042-7684c019e1cb?w=400',
    },
  ],
};

export const themes = [
  {
    id: 'birthday-party',
    name: 'Birthday Party',
    description: 'Classic birthday celebration with decorations, games, and fun activities for the birthday child and friends',
    image: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=600',
    tag: 'POPULAR',
  },
  {
    id: 'children-holiday',
    name: "Children's Holiday",
    description: 'Special themed celebrations for holidays - Christmas, Easter, Halloween and more magical occasions',
    image: 'https://images.unsplash.com/photo-1513151233558-d860c5398176?w=600',
    tag: 'CLASSIC',
  },
];

export const galleryImages = [
  {
    id: 1,
    url: 'https://images.unsplash.com/photo-1762912913371-ccc0a5fca0ae?w=800',
    alt: 'Happy birthday celebration',
    category: 'parties',
  },
  {
    id: 2,
    url: 'https://images.unsplash.com/photo-1756621716915-cb8723574795?w=800',
    alt: 'Themed party with balloons',
    category: 'parties',
  },
  {
    id: 3,
    url: 'https://images.unsplash.com/photo-1756621716907-6451161cd100?w=800',
    alt: 'Happy child at party',
    category: 'parties',
  },
  {
    id: 4,
    url: 'https://images.unsplash.com/photo-1756621716318-9eec89d42715?w=800',
    alt: 'Kids having fun',
    category: 'parties',
  },
  {
    id: 5,
    url: 'https://images.unsplash.com/photo-1602328790041-ee36d98e677c?w=800',
    alt: 'Colorful balloons',
    category: 'decorations',
  },
  {
    id: 6,
    url: 'https://images.pexels.com/photos/35224348/pexels-photo-35224348.jpeg?w=800',
    alt: 'Party treats',
    category: 'food',
  },
  {
    id: 7,
    url: 'https://images.pexels.com/photos/35224368/pexels-photo-35224368.jpeg?w=800',
    alt: 'Party setup',
    category: 'decorations',
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Jenkins',
    role: 'Mom of 7-year-old Lily',
    comment: 'The best birthday we\'ve ever hosted! Children Planet took care of everything. From the themed decorations to the amazing animator, our daughter and her friends were entertained for the full 2 hours. Highly recommend the Super Star package!',
    rating: 5,
    avatar: 'https://i.pravatar.cc/150?img=1',
  },
  {
    id: 2,
    name: 'Emma Johnson',
    role: 'Happy Parent',
    comment: 'The best birthday experience we\'ve ever had! The animators were incredible, and I didn\'t have to lift a finger. Sarah is still talking about her jungle party three months later!',
    rating: 5,
    avatar: 'https://i.pravatar.cc/150?img=5',
  },
  {
    id: 3,
    name: 'Michael Chen',
    role: 'Father of Two',
    comment: 'Outstanding service and attention to detail. The kids had an amazing time and the food was excellent. Worth every penny!',
    rating: 5,
    avatar: 'https://i.pravatar.cc/150?img=12',
  },
];

export const mockBookings = [
  {
    id: 'BK001',
    date: '2025-02-15',
    time: '14:00',
    package: 'Super Star',
    guests: 15,
    status: 'confirmed',
    total: 570.0,
    addOns: ['Face Painting', 'Photo Pack'],
  },
  {
    id: 'BK002',
    date: '2025-01-20',
    time: '11:00',
    package: 'Mini Magic',
    guests: 10,
    status: 'completed',
    total: 330.0,
    addOns: ['Bubble Show'],
  },
];

export const mockPayments = [
  {
    id: 'PAY001',
    bookingId: 'BK001',
    date: '2025-01-10',
    amount: 570.0,
    method: 'Stripe',
    status: 'paid',
  },
  {
    id: 'PAY002',
    bookingId: 'BK002',
    date: '2024-12-15',
    amount: 330.0,
    method: 'PayPal',
    status: 'paid',
  },
];

export const whyChooseUs = [
  {
    id: 1,
    icon: '🛡️',
    title: 'Safe Play Zones',
    description: 'State-of-the-art equipment designed for maximum safety and endless fun under constant supervision',
  },
  {
    id: 2,
    icon: '🎭',
    title: 'Expert Animators',
    description: 'Professional entertainers who bring your child\'s favorite storybook characters and dreams to life',
  },
  {
    id: 3,
    icon: '🍽️',
    title: 'Kid-Friendly Menu',
    description: 'Nutritious and delicious gourmet catering options designed for picky eaters and all dietary needs',
  },
];
